import React from 'react'
import SelectBox from './common/SelectBox'
import {connect} from 'react-redux'
import {
  getExpensesDisabled,
  getLoanApplication,
  isSecondaryUser
} from '../../../reducers'

class MaritalStatus extends React.Component {
  render() {
    const {
      onStatusChange,
      maritalStatus,
      hasSecondaryApplicant,
      expensesDisabled,
      isSecondaryUser,
    } = this.props

    const maritalStatusText = hasSecondaryApplicant ? 'We are' : 'I am'

    return (
      <div className='card card-single'>
        <div className='card-body'>
          <div className='qn'>
            Marital Status
          </div>

          <div className='grey smaller mb-2'>
            Which best describes your current situation?
          </div>
          <div className='row no-gutters'>
            {!hasSecondaryApplicant &&
              <div className='col-12 col-sm-6'>
                <SelectBox
                  name={'marital-status'}
                  disabled={ expensesDisabled }
                  checked={ maritalStatus === 'single' }
                  value={'single'}
                  text={'I am single'}
                  onChange={onStatusChange}
                />
              </div>
            }
            <div className='col-12 col-sm-6'>
              <SelectBox
                name={'marital-status'}
                disabled={ expensesDisabled }
                checked={ maritalStatus === 'married' }
                value={'married'}
                text={`${maritalStatusText} married`}
                onChange={onStatusChange}
              />
            </div>
            <div className='col-12 col-sm-6'>
              <SelectBox
                name={'marital-status'}
                disabled={ expensesDisabled }
                checked={ maritalStatus === 'defacto' }
                value={'defacto'}
                text={`${maritalStatusText} de facto`}
                onChange={onStatusChange}
              />
            </div>
            {!hasSecondaryApplicant &&
              <div className='col-12 col-sm-6'>
                <SelectBox
                  name={'marital-status'}
                  disabled={ expensesDisabled }
                  checked={ maritalStatus === 'separated' }
                  value={'separated'}
                  text={'I am separated'}
                  onChange={onStatusChange}
                />
              </div>
            }
          </div>
        </div>
      </div>
    )
  }

  renderBoolQuestion(id, text, checked, onChange) {
    const {
      expensesDisabled,
    } = this.props

    return (<div className='mt-4'>
      <div className='grey smaller mb-2'>
        { text }
      </div>
      <div className='row no-gutters'>
        <div className='col-12 col-sm-6'>
          <SelectBox
            name={id}
            disabled={ expensesDisabled }
            checked={ checked === true }
            value={true}
            text='Yes'
            onChange={ onChange }
          />
        </div>
        <div className='col-12 col-sm-6'>
          <SelectBox
            name={id}
            disabled={ expensesDisabled }
            checked={ checked === false }
            value={false}
            text='No'
            onChange={ onChange }
          />
        </div>
      </div>
    </div>)
  }
}

const mapStateToProps = (state) => ({
  primaryEntersData: getLoanApplication(state).primaryEntersData,
  hasSecondaryApplicant: getLoanApplication(state).hasSecondaryApplicant,
  isSecondaryUser: isSecondaryUser(state),
  expensesDisabled: getExpensesDisabled(state)
})


export default connect(mapStateToProps, {})(MaritalStatus)
